// extracted by mini-css-extract-plugin
export default {"label":"FormLabel_label__BoblF","required":"FormLabel_required__WEZDO","bold":"FormLabel_bold__7wloD"};